/**
 * Cross-component signal that a game's player segments changed (one was created, edited, cloned or deleted),
 * so the header's geography switcher re-reads them. Reported from QA: a geography added on the Segments page
 * did not appear in the switcher until the game was switched or the page reloaded - the header loads the
 * list once per game. The header listens for {@link SEGMENTS_CHANGED_EVENT}; PlayerSegmentService fires it
 * after every successful write. Mirrors gamesChanged.js.
 */
export const SEGMENTS_CHANGED_EVENT = 'gp-segments-changed';

/** Fire-and-forget: tell mounted listeners that `gameId`'s segments changed. */
export function notifySegmentsChanged(gameId) {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(SEGMENTS_CHANGED_EVENT, { detail: { gameId: gameId ?? null } }));
    }
}

/**
 * Whether a change event concerns the game the header shows. An event without a game id (the service was
 * called without one, so the request used the selected game) counts.
 */
export function concernsGame(event, selectedGameId) {
    const changed = event?.detail?.gameId;
    return !changed || changed === selectedGameId;
}
